import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../../config";
import Sidebar from "./Sidebar";
import AssessmentTopNav from "./topnav";
import axios from "axios";
import "../../../Styles/Admin/assessment/Quizzes.css";

const Quizzes = () => {
  const [quizzes, setQuizzes] = useState([]);
  const [questionCounts, setQuestionCounts] = useState({});
  const [search, setSearch] = useState("");
  const [filtered, setFiltered] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("add");
  const [modalQuiz, setModalQuiz] = useState({ id: null, category: "" });
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteQuizId, setDeleteQuizId] = useState(null);

  const [successAlert, setSuccessAlert] = useState("");
  const [errorAlert, setErrorAlert] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    fetchQuizzes();
  }, []);

  useEffect(() => {
    if (!search.trim()) {
      setFiltered(quizzes);
      return;
    }
    const term = search.toLowerCase();
    setFiltered(
      quizzes.filter((q) => q.category.toLowerCase().includes(term))
    );
  }, [quizzes, search]);

  const fetchQuizzes = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/quizzes`);
      setQuizzes(res.data);
      setFiltered(res.data);
      fetchQuestionCounts(res.data);
    } catch (err) {
      console.error(err);
    }
  };


  const fetchQuestionCounts = async (quizList) => {
    const entries = await Promise.all(
      quizList.map(async (quiz) => {
        try {
          const res = await axios.get(
            `${API_BASE_URL}/api/questions/${encodeURIComponent(
              quiz.category
            )}`
          );
          return [quiz.category, Array.isArray(res.data) ? res.data.length : 0];
        } catch (err) {
          return [quiz.category, 0];
        }
      })
    );
    setQuestionCounts(Object.fromEntries(entries));
  };

  const openAddModal = () => {
    setModalType("add");
    setModalQuiz({ id: null, category: "" });
    setModalOpen(true);
  };

  const openEditModal = (quiz) => {
    setModalType("edit");
    setModalQuiz({ id: quiz.id, category: quiz.category });
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalQuiz({ id: null, category: "" });
  };

  const handleModalChange = (e) => {
    setModalQuiz({ ...modalQuiz, [e.target.name]: e.target.value });
  };

  const handleModalSave = async () => {
    if (!modalQuiz.category.trim()) return;
    try {
      if (modalType === "add") {
        await axios.post(`${API_BASE_URL}/api/quizzes`, {
          category: modalQuiz.category,
          date_added: new Date().toISOString().slice(0, 10),
          questions: "",
        });
        setSuccessAlert("Quiz added successfully!");
      } else {
        await axios.post(`${API_BASE_URL}/api/quizzes/edit/${modalQuiz.id}`, {
          category: modalQuiz.category,
          date_added: new Date().toISOString().slice(0, 10),
          questions: "",
        });
        setSuccessAlert("Quiz updated successfully!");
      }
      closeModal();
      fetchQuizzes();
      setTimeout(() => setSuccessAlert(""), 2000);
    } catch (err) {
      console.error(err);
    }
  };

  const openDeleteModal = (id) => {
    setDeleteQuizId(id);
    setDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteQuizId(null);
    setDeleteModalOpen(false);
  };

  const confirmDelete = async () => {
    try {
      await axios.post(`${API_BASE_URL}/api/quizzes/delete/${deleteQuizId}`);
      closeDeleteModal();
      fetchQuizzes();
      setErrorAlert("Quiz deleted successfully!");
      setTimeout(() => setErrorAlert(""), 2000);
    } catch (err) {
      console.error(err);
    }
  };

  const questionCount = (quiz) => questionCounts[quiz.category] ?? 0;

 return (
    <div className="quizzes-layout">
      <Sidebar />
      <div className="quizzes-body">
        <AssessmentTopNav title="ASSESSMENT" />
        <main className="quizzes-main">
          <header className="quizzes-header">
            <h1 className="quizzes-title">Quizzes</h1>
            <p className="quizzes-subtitle">
              Manage and Organize all assessment quizzes
            </p>
          </header>

          <section className="quizzes-toolbar-card">
            <div className="quizzes-search-wrap">
              <img
                src="/searchs_icon.png"
                alt=""
                className="quizzes-search-icon"
              />
              <input
                type="text"
                placeholder="Search Quiz Name"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="quizzes-search-input"
              />
            </div>

            <button className="quizzes-create-btn" onClick={openAddModal}>
              <img
                src="/plus_icons.png"
                alt=""
                className="quizzes-plus-icon"
              />
              Create New Quizze
            </button>
          </section>

          {successAlert && (
            <div className="quizzes-success-alert">{successAlert}</div>
          )}
          {errorAlert && (
            <div className="quizzes-error-alert">{errorAlert}</div>
          )}

          <section className="quizzes-table-card">
            <div className="quizzes-table-scroll">
              <table className="quizzes-table">
                <thead>
                   <tr>
    <th>S.No</th>
    <th>Quiz Name</th>
    {/* Date Added column hidden — data still fetched, just not rendered */}
    <th>Questions</th>
    <th>Actions</th>
  </tr>
                </thead>
                <tbody>
                  {filtered.length === 0 ? (
                    <tr>
                      <td colSpan={4} className="quizzes-empty-cell">
                        No quizzes found.
                      </td>
                    </tr>
                  ) : (
                    filtered.map((quiz, idx) => (
                      <tr key={quiz.id}>
                        <td>{String(idx + 1).padStart(2, "0")}</td>
                        <td className="quizzes-name-cell">{quiz.category}</td>
                        {/* Date Added cell hidden — quiz.date_added still available in state/backend */}
                        <td>
                          <button
                            type="button"
                            className="quizzes-question-badge"
                            onClick={() =>
                              navigate(
                                `/admin/assessment/questions?category=${encodeURIComponent(
                                  quiz.category
                                )}`
                              )
                            }
                          >
                            {questionCount(quiz)} Questions
                          </button>
                        </td>
                        <td>
                          <div className="quizzes-actions-cell">
                            <button
                              className="quizzes-edit-btn"
                              onClick={() => openEditModal(quiz)}
                            >
                              <img
                                src="/edits_out_icon.png"
                                alt=""
                                className="quizzes-btn-icon"
                              />
                              Edit
                            </button>
                            <button
                              className="quizzes-delete-btn"
                              onClick={() => openDeleteModal(quiz.id)}
                            >
                              <img
                                src="/deletes_out_icon.png"
                                alt=""
                                className="quizzes-btn-icon"
                              />
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </section>
        </main>
      </div>

      {modalOpen && (
        <div className="quizzes-modal-overlay">
          <div className="quizzes-modal">
            <div className="quizzes-modal-title">
              {modalType === "add" ? "Create New Quizze" : "Edit Quiz Name"}
            </div>
            <label className="quizzes-modal-label" htmlFor="category">
              Quiz Name
            </label>
            <input
              className="quizzes-modal-input"
              id="category"
              name="category"
              value={modalQuiz.category}
              onChange={handleModalChange}
              placeholder="Enter quiz name"
              autoFocus
            />
            <div className="quizzes-modal-actions">
              <button className="quizzes-modal-cancel" onClick={closeModal}>
                Cancel
              </button>
              <button className="quizzes-modal-save" onClick={handleModalSave}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {deleteModalOpen && (
        <div className="quizzes-delete-modal-overlay">
          <div className="quizzes-delete-modal">
            <div className="delete-icon">
              <img
                src="/delete_alert_icons.png"
                alt=""
                className="delete-icon-img"
              />
            </div>
            <div className="quizzes-delete-modal-title">Delete Information</div>
            <div className="quizzes-delete-modal-desc">
              This Record will be deleted
            </div>
            <div className="quizzes-delete-modal-actions">
              <button
                className="quizzes-delete-modal-no"
                onClick={closeDeleteModal}
              >
                No, Keep it
              </button>
              <button
                className="quizzes-delete-modal-yes"
                onClick={confirmDelete}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Quizzes;